import { FaEye } from "react-icons/fa";
import AttachmentItem from "components/Attachments/AttachmentItem";
import CopyAttachmentButton from "components/Attachments/CopyAttachmentButton";
import { isPreviewableImage } from "utils/attachmentPreview";
import { getFileIcon, getOriginalFileName } from "utils/utils";

const FileRow = ({ url }) => (
  <li className="flex items-center gap-3 rounded-lg border border-app-border p-2">
    <div className="w-9 h-9 bg-app-surface-muted rounded-md flex items-center justify-center shrink-0">
      {getFileIcon(url)}
    </div>
    <p className="text-sm font-medium text-app-text truncate flex-1 m-0">
      {getOriginalFileName(url) || "File"}
    </p>
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="text-xs text-primary hover:opacity-80 flex items-center gap-1 no-underline"
    >
      <FaEye />
      View
    </a>
    <CopyAttachmentButton url={url} />
  </li>
);

/** A task's attached files: images as previewable thumbnails, everything else as a row that opens in a new tab. */
const TaskAttachmentList = ({ attachments = [] }) => {
  const images = attachments.filter((url) => isPreviewableImage(url));
  const files = attachments.filter((url) => !isPreviewableImage(url));

  return (
    <div className="space-y-3">
      {images.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {images.map((url, index) => (
            <AttachmentItem
              key={`${url}-${index}`}
              url={url}
              renderFile={(fileUrl) => (
                <ul className="m-0 p-0 list-none">
                  <FileRow url={fileUrl} />
                </ul>
              )}
            />
          ))}
        </div>
      )}
      {files.length > 0 && (
        <ul className="space-y-2 m-0 p-0 list-none">
          {files.map((url, index) => (
            <FileRow key={`${url}-${index}`} url={url} />
          ))}
        </ul>
      )}
    </div>
  );
};

export default TaskAttachmentList;
